/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el         = $(el);
const $form       = $el.find('#formNewsletter');
const $success    = $el.find('.success');
const $textInputs = el.querySelectorAll('.box-input input[type="type-neutral"]');

var maskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
}, options = {
    onKeyPress: function(val, e, field, options) {
        field.mask(maskBehavior.apply({}, arguments), options);
    }
};

if(document.documentElement.lang == 'pt') {
    $el.find('#cellphoneNewsletter').mask(maskBehavior, options);
}

const removeError = ($el) => {
    $el.parentElement.classList.remove('error');
};

const addError = ($el) => {
    $el.parentElement.classList.add('error');
};

$form.on('submit', function(e) {
    e.preventDefault();

    let error = false;

    $textInputs.forEach(function ($input) {
        if($input.value === '') {
            error = true;

            addError($input);
        } else {
            if($input.id === 'emailNewsletter') {
                // verify email
                const email = $input.value;
                const regex = /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/;

                if(!regex.test(email)) {
                    error = true;

                    addError($input);
                } else {
                    removeError($input);
                }
            } else if($input.id === 'cellphoneNewsletter') {
                // verify phone number
                const phone = $input.value;
                const regex = /^\(\d{2}\) \d{4,5}-?\d{4}$/;

                if(!regex.test(phone)) {
                    error = true;

                    addError($input);
                } else {
                    removeError($input);
                }
            } else {
                removeError($input);
            }
        }
    });

    console.log(error);

    if(!error) {
        const data = $form.serialize();
        const $btn = $form.find('[type="submit"]');

        $btn.attr('disabled', true);
        $form.find('input').attr('disabled', true);
        $.ajax({
            url: `${base}api/newsletter`,
            type: 'POST',
            data: data,
            dataType: 'json',
            success: function(response) {
                if (!response.error) {
                    $form.hide();
                    $success.show();
                } else {
                    $form.show();
                    $success.hide();
                }

                $btn.attr('disabled', false);
                $form.find('input').attr('disabled', false);
            },
            error: function(response) {
                console.log(response.responseText);
            }
        });
    }
});
